// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Dark Mode Toggle Styles */
.dark-mode-toggle {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  background: white;
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 0.9rem;
  color: #64748b;
  position: relative;
  overflow: hidden;
}

.dark-mode-toggle:hover {
  border-color: #3b82f6;
  color: #3b82f6;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.15);
}

.dark-mode-toggle.dark {
  background: linear-gradient(135deg, #1e293b 0%, #334155 100%);
  border-color: #475569;
  color: #e2e8f0;
}

.dark-mode-toggle.dark:hover {
  border-color: #8b5cf6;
  color: #8b5cf6;
  box-shadow: 0 4px 12px rgba(139, 92, 246, 0.15);
}

.toggle-icon {
  font-size: 1.2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.5rem;
  height: 1.5rem;
}

.toggle-text {
  font-size: 0.85rem;
  font-weight: 600;
  white-space: nowrap;
}

/* Responsive Design */
@media (max-width: 768px) {
  .dark-mode-toggle {
    padding: 0.4rem 0.75rem;
    font-size: 0.8rem;
  }
  
  .toggle-text {
    display: none;
  }
  
  .toggle-icon {
    font-size: 1.1rem;
  }
}

@media (max-width: 480px) {
  .dark-mode-toggle {
    padding: 0.35rem 0.6rem;
    min-width: 2.5rem;
    justify-content: center;
  }
}

`, "",{"version":3,"sources":["webpack://./src/components/DarkModeToggle.css"],"names":[],"mappings":"AAAA,4BAA4B;AAC5B;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,6DAA6D;EAC7D,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,+CAA+C;AACjD;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE;IACE,uBAAuB;IACvB,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,uBAAuB;IACvB,iBAAiB;IACjB,uBAAuB;EACzB;AACF","sourcesContent":["/* Dark Mode Toggle Styles */\r\n.dark-mode-toggle {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.5rem;\r\n  padding: 0.5rem 1rem;\r\n  background: white;\r\n  border: 2px solid #e2e8f0;\r\n  border-radius: 12px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: all 0.3s ease;\r\n  font-size: 0.9rem;\r\n  color: #64748b;\r\n  position: relative;\r\n  overflow: hidden;\r\n}\r\n\r\n.dark-mode-toggle:hover {\r\n  border-color: #3b82f6;\r\n  color: #3b82f6;\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.15);\r\n}\r\n\r\n.dark-mode-toggle.dark {\r\n  background: linear-gradient(135deg, #1e293b 0%, #334155 100%);\r\n  border-color: #475569;\r\n  color: #e2e8f0;\r\n}\r\n\r\n.dark-mode-toggle.dark:hover {\r\n  border-color: #8b5cf6;\r\n  color: #8b5cf6;\r\n  box-shadow: 0 4px 12px rgba(139, 92, 246, 0.15);\r\n}\r\n\r\n.toggle-icon {\r\n  font-size: 1.2rem;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 1.5rem;\r\n  height: 1.5rem;\r\n}\r\n\r\n.toggle-text {\r\n  font-size: 0.85rem;\r\n  font-weight: 600;\r\n  white-space: nowrap;\r\n}\r\n\r\n/* Responsive Design */\r\n@media (max-width: 768px) {\r\n  .dark-mode-toggle {\r\n    padding: 0.4rem 0.75rem;\r\n    font-size: 0.8rem;\r\n  }\r\n  \r\n  .toggle-text {\r\n    display: none;\r\n  }\r\n  \r\n  .toggle-icon {\r\n    font-size: 1.1rem;\r\n  }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .dark-mode-toggle {\r\n    padding: 0.35rem 0.6rem;\r\n    min-width: 2.5rem;\r\n    justify-content: center;\r\n  }\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
